<template>
  <div>
    <v-card-title class="pa-1">
      <v-row>
        <v-col cols="6" class="pa-1">
          {{ model.id ? this.$t('message.product.updateProduct') : this.$t('message.product.addProduct') }}
        </v-col>
        <v-col cols="6" class="pa-1 text-right" v-if="copyProduct && copyProduct.isshow && model.ispackage">
          <v-btn small icon text color="primary" @click="copyProduct.open"><v-icon>mdi-content-copy</v-icon></v-btn>
        </v-col>
      </v-row>
    </v-card-title>
    <v-divider></v-divider>
    <v-card-text>
      <v-form ref="validateForm" autocomplete="off">
        <v-row>
          <v-col cols="12" sm="6" md="3" lg="2" class="pa-2">
            <v-text-field outlined hide-details :rules="$_requiredValidation" v-model="model.number" :label="$t('message.product.number')" dense @change="changesMade" @blur="checkForNumberDuplication"></v-text-field>
          </v-col>
          <v-col cols="12" sm="6" md="3" lg="2" class="pa-2">
            <v-text-field outlined hide-details :rules="$_requiredValidation" v-model="model.number_barcode" :label="$t('message.product.numberBarcode')" dense @change="changesMade"></v-text-field>
          </v-col>
          <v-col cols="12" sm="6" md="3" lg="3" class="pa-2">
            <v-text-field outlined hide-details :rules="$_requiredValidation" v-model="model.name" :label="$t('message.customer.name')" dense @change="changesMade"></v-text-field>
          </v-col>
          <v-col cols="12" sm="6" md="3" lg="1" class="pa-2">
            <v-text-field outlined hide-details v-model="model.shortname" :label="$t('message.product.shortName')" dense @change="changesMade"></v-text-field>
          </v-col>
          <v-col cols="12" sm="6" md="3" lg="2" class="pa-2">
            <v-select outlined dense :items="listOfTypes" :rules="$_requiredValidation" v-model="model.type" item-text="text" item-value="value" hide-details :label="$t('message.product.type')" @change="changesMade"></v-select>
          </v-col>
          <v-col cols="12" sm="6" md="3" lg="2" class="pa-2">
            <v-autocomplete outlined dense :items="list.groups" @change="$emit('gross-margin'), changesMade"
              append-icon="add_circle" @click:append="$emit('supportingList', PRODUCT_GROUPS, 'productgroupid')"
              ref="productgroupid" autocomplete="off" :rules="$_requiredValidation" v-model="model.productgroupid"
              @click:clear="$nextTick(() => model.productgroupid = null)" :item-text="(x) => `${x.number ? x.number + ' - ' : ''} ${x.name}`" item-value="id" hide-details :label="$t('message.user.group')"></v-autocomplete>
          </v-col>
          <v-col cols="12" sm="6" md="2" lg="1" class="pa-2">
            <v-checkbox dense hide-details color="primary" v-model="model.isactive" :label="$t('message.common.isActive')" @change="changesMade"></v-checkbox>
          </v-col>
          <v-col cols="12" sm="6" md="3" lg="1" class="pa-2" v-if="isWorkType">
            <v-checkbox dense hide-details color="primary" v-model="model.stockitem" :label="$t('message.product.isStockItem')" @change="changesMade"></v-checkbox>
          </v-col>
          <v-col cols="12" sm="6" md="3" lg="2" class="pa-2" v-if="isWorkType">
            <v-checkbox dense hide-details color="primary" v-model="model.notinventoryitem" :label="$t('message.product.isNotInventoryItem')" @change="changesMade"></v-checkbox>
          </v-col>
          <v-col cols="12" sm="6" md="3" lg="2" class="pa-2" v-if="isWorkType">
            <v-checkbox dense hide-details color="primary" v-model="model.certificaterequired" :label="$t('message.product.certificateReq')" @change="changesMade"></v-checkbox>
          </v-col>
          <v-col cols="12" sm="6" md="3" lg="1" class="pa-2" v-if="isWorkType">
            <v-checkbox dense hide-details color="primary" v-model="model.ispackage" :label="$t('message.product.isPackage')" @change="changesMade"></v-checkbox>
          </v-col>
          <v-col cols="12" sm="6" md="3" lg="2" class="pa-2" v-if="model.ispackage">
            <v-checkbox dense hide-details color="primary" v-model="model.openstructure" :label="$t('message.warehouse.openStructure')" @change="changesMade"></v-checkbox>
          </v-col>
          <v-col cols="12" sm="6" md="3" lg="1" class="pa-2" v-if="isWorkType">
            <v-checkbox dense hide-details color="primary" v-model="model.batchrequired" :label="$t('message.product.batchRequired')" @change="changesMade"></v-checkbox>
          </v-col>
          <v-col cols="12" sm="6" md="3" lg="2" class="pa-2" v-if="isWorkType">
            <v-checkbox dense hide-details color="primary" v-model="model.isproduction" :label="$t('message.product.production')" @change="changesMade"></v-checkbox>
          </v-col>
          <v-col cols="12" sm="6" md="3" lg="2" class="pa-2" v-if="!model.stockitem">
            <v-checkbox dense hide-details color="primary" v-model="model.issupplieronorder" :label="$t('message.order.supplierOnOrder')" @change="changesMade"></v-checkbox>
          </v-col>
          <v-col cols="12" sm="6" md="3" lg="2" class="pa-2" v-if="isWorkType">
            <v-checkbox dense hide-details color="primary" v-model="model.isinformation" :label="$t('message.product.isInformation')" @change="changesMade"></v-checkbox>
          </v-col>
          <v-col cols="12" sm="6" md="3" lg="2" class="pa-2" v-if="isWorkType">
            <v-checkbox dense hide-details color="primary" v-model="model.showalllocationsonpicklist" :label="$t('message.warehouse.showAllLocations')" @change="changesMade"></v-checkbox>
          </v-col>
          <v-col cols="12" sm="6" md="3" lg="2" class="pa-2" v-if="isWorkType">
            <v-text-field outlined hide-details label="HS" v-model="model.hs" dense @change="changesMade"></v-text-field>
          </v-col>
          <v-col cols="12" sm="6" md="3" lg="2" class="pa-2" v-if="isWorkType">
            <v-text-field outlined hide-details label="COO" v-model="model.coo" dense @change="changesMade"></v-text-field>
          </v-col>
          <v-col cols="12" sm="6" md="3" lg="2" class="pa-2">
            <v-text-field outlined hide-details :label="$t('message.warehouse.drawing')" v-model="model.drawing" dense @change="changesMade"></v-text-field>
          </v-col>
        </v-row>
        <v-row v-if="!model.isinformation">
          <v-col lg="10" cols="12">
            <v-subheader class="pl-0 font-weight-bold body-1">{{ $t('message.product.prices') }}:</v-subheader>
            <v-divider></v-divider>
            <v-row>
              <v-col cols="12" sm="6" md="2" lg="2" class="pa-2">
                <v-text-field outlined hide-details :rules="$_norwegianNumberValidation"
                  v-model="model.costprice" :label="$t('message.product.costPrice')" :readonly="isWorkType || !isAdmin" @change="calculateSalesValue" dense></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="2" lg="2" class="pa-2">
                <v-text-field outlined hide-details :rules="$_norwegianNumberMinusValidation" :readonly="!isAdmin" @change="calculateSalesValue" v-model="model.grosmargin" :label="$t('message.product.grossMargin')" dense></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="2" lg="2" class="pa-2">
                <v-text-field outlined hide-details :rules="$_norwegianNumberValidation" :readonly="!isAdmin" @change="calculateGrosMarginValue" v-model="model.salesprice" :label="$t('message.product.salePriceExVat')" dense></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="2" lg="2" class="pa-2">
                <v-text-field outlined hide-details :rules="$_norwegianNumberValidation" :readonly="!isAdmin" @change="salesPriceHandler('salesprice', 'salespriceincvat', 2)" v-model="model.salespriceincvat" :label="$t('message.product.salePriceIncVat')" dense></v-text-field>
              </v-col>
              <!-- <v-col cols="12" sm="6" md="2" lg="2" class="pa-2">
                <v-text-field outlined hide-details :rules="$_norwegianNumberValidation" v-model="model.baseprice" :label="$t('message.product.basePrice')" dense></v-text-field>
              </v-col> -->
              <v-col cols="12" sm="6" md="3" lg="2" class="pa-2">
                <v-menu :close-on-content-click="false" v-model="model.priceValidMenu" transition="scale-transition" offset-y min-width="290px">
                  <template v-slot:activator="{ on }">
                    <v-text-field outlined hide-details dense clearable :label="$t('message.product.priceValidFrom')" prepend-icon="event"
                    readonly v-on="on" v-model="model.pricevalidfrom" :rules="$_requiredValidation"
                    @click:clear="$nextTick(() => model.priceValidFromPicker = null)"></v-text-field>
                  </template>
                  <v-date-picker color="primary" v-model="model.priceValidFromPicker" @input="model.priceValidMenu = false" first-day-of-week='1'></v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="12" sm="6" md="2" lg="1" class="pa-2">
                <v-select outlined dense :items="listOfVAT" @change="salesPriceHandler('salespriceincvat', 'salesprice', 1)" :rules="$_selectRequiredValidation" v-model="model.vatid" item-text="text" item-value="value" hide-details :label="$t('message.customer.vatId')"></v-select>
              </v-col>
              <v-col cols="12" sm="6" md="3" lg="1" class="pa-2">
                <v-select outlined dense :rules="$_requiredValidation" :items="list.sales_accounts" v-model="model.salesaccountid" item-text="accountnumber" item-value="id" hide-details :label="$t('message.product.salesAccount')"></v-select>
              </v-col>
            </v-row>
            <v-row v-if="showPriceUpdateText">
              <v-col cols="8" class="pt-0 pb-0 font-color">
                <h4>{{ $t('message.product.priceAdjustmentAdded') }}</h4>
              </v-col>
            </v-row>
          </v-col>
          <v-col lg="2" cols="12">
            <!-- <v-subheader v-if="isWorkType" class="pl-0 font-weight-bold body-1">{{ $t('message.product.stocks') }}:</v-subheader>
            <v-row v-if="isWorkType">
              <v-col cols="12" class="pa-2">
                <v-text-field outlined hide-details readonly v-model="model.available" :label="$t('message.product.available')" dense></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="3" lg="2" class="pa-2">
                <v-text-field outlined hide-details :rules="$_norwegianNumberValidation" v-model="model.minstock" :label="$t('message.product.minStock')" dense></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="3" lg="2" class="pa-2">
                <v-text-field outlined hide-details :rules="$_norwegianNumberValidation" v-model="model.orderqty" :label="$t('message.product.orderQty')" dense></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="3" lg="2" class="pa-2">
                <v-text-field outlined hide-details :rules="$_norwegianNumberValidation" v-model="model.leadtime" :label="$t('message.product.leadTime')" dense></v-text-field>
              </v-col>
            </v-row> -->
          </v-col>
        </v-row>
        <template v-if="!model.isinformation">
          <v-row>
            <v-col cols="8" class="pt-0 pb-0">
              <v-subheader v-if="isWorkType" class="pl-0 font-weight-bold body-1">{{ $t('message.product.units') }}:</v-subheader>
              <v-simple-table dense class="bordered--table elevation-1" :key="reInit">
                <template v-slot:default>
                  <tbody>
                    <tr>
                      <td width="15%"> {{ $t('message.product.unit') }} </td>
                      <td width="12%">{{ $t('message.product.qty') }}</td>
                      <td width="12%">{{ $t('message.product.minQty') }}</td>
                      <td width="12%">{{ $t('message.product.orderQty') }}</td>
                      <td width="10%">{{ $t('message.product.salesUnit') }}</td>
                      <td width="10%">{{ $t('message.product.supplier') }}</td>
                      <td width="20%">{{ $t('message.product.ean') }}</td>
                      <td class="text-center">
                        <v-btn color="success" text fab dark small class="mt-n1" @click="addOrReomveProductUnit('PUSH')"> <v-icon dark>mdi-plus-circle</v-icon> </v-btn>
                      </td>
                    </tr>
                    <tr v-for="(unit, index) in model.units" :key="index">
                      <td class="pl-1 pr-1">
                        <v-select dense :items="list.units" item-text="name" autocomplete="off" :rules="$_requiredValidation" v-model="unit.unitid"
                          item-value="id" @click:clear="$nextTick(() => unit.unitid = null)" ref="unitid" hide-details @change="changesMade"></v-select>
                      </td>
                      <td class="pl-1 pr-1">
                        <v-text-field v-model="unit.qty" :rules="unit.qty ? $_norwegianNumberValidation : $_requiredValidation" dense hide-details></v-text-field>
                      </td>
                      <td class="pl-1 pr-1">
                        <v-text-field v-if="unit.issupplier" v-model="unit.minqty" :rules="$_norwegianNumberMinusValidation" dense hide-details></v-text-field>
                      </td>
                      <td class="pl-1 pr-1">
                        <v-text-field v-if="unit.issupplier" v-model="unit.orderqty" :rules="$_norwegianNumberValidation" dense hide-details></v-text-field>
                      </td>
                      <td class="pl-1 pr-1">
                        <v-checkbox class="ml-8 pa-0 mt-0" color="primary" v-model="unit.issaleunit" hide-details dense @change="updateSaleUnitInList(index, unit.issaleunit)"></v-checkbox>
                      </td>
                      <td class="pl-1 pr-1">
                        <v-checkbox class="ml-8 pa-0 mt-0" color="primary" v-model="unit.issupplier" hide-details dense @change="reInit++"></v-checkbox>
                      </td>
                      <td class="pl-1 pr-1">
                        <v-text-field v-model="unit.ean" dense hide-details></v-text-field>
                      </td>
                      <td class="text-center pl-1 pr-1">
                        <v-btn icon text @click="addOrReomveProductUnit('POP', index)"> <v-icon color="error">mdi-delete</v-icon></v-btn>
                      </td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-col>
            <v-col cols="4" class="pt-0 pb-0">
              <template v-if="model.stockitem">
                <v-subheader v-if="isWorkType" class="pl-0 font-weight-bold body-1">{{ $t('message.product.defaultLocation') }}:</v-subheader>
                <v-divider v-if="isWorkType"></v-divider>
                <v-simple-table dense class="bordered--table elevation-1" :key="reInitLoc">
                  <template v-slot:default>
                    <tbody>
                      <tr>
                        <td width="45%"> {{ $t('message.layout.warehouse') }} </td>
                        <td width="45%">{{ $t('message.layout.location') }}</td>
                        <td class="text-center">
                          <v-btn color="success" text fab dark small class="mt-n1" @click="addOrReomveProductLocations('PUSH')"> <v-icon dark>mdi-plus-circle</v-icon> </v-btn>
                        </td>
                      </tr>
                      <tr v-for="(location, index) in model.defaultlocations" :key="index">
                        <td class="pl-1 pr-1">
                          <template v-if="location.warehousename">
                            {{ location.warehousename }}
                          </template>
                          <v-select v-else dense :items="list.warehouse" item-text="name" autocomplete="off" :rules="$_requiredValidation" v-model="location.warehouseid"
                            item-value="id" @click:clear="$nextTick(() => location.warehouseid = null)" ref="warehouseid" hide-details
                            @change="selectWarehouse(index)"></v-select>
                        </td>
                        <td class="pl-1 pr-1">
                          <v-text-field v-model="location.locationname"
                          @change="checkIfLocationValid(index, location.warehouseid, location.locationname)"
                          :rules="$_requiredValidation" dense hide-details></v-text-field>
                        </td>
                        <td class="text-center pl-1 pr-1">
                          <v-btn icon text @click="addOrReomveProductLocations('POP', index)"> <v-icon color="error">mdi-delete</v-icon></v-btn>
                        </td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </template>
            </v-col>
          </v-row>
        </template>
      </v-form>
      <template v-if="model.id && model.sharepoint_link">
        <v-subheader class="pl-0 font-weight-bold body-1">{{ $t('message.onedriveSettings.odLink') }}:</v-subheader>
        <v-divider></v-divider>
        <v-row>
          <v-col cols="12" class="pa-2">
            <label class="pa-2" ><a  target="_blank" :href="model.sharepoint_link">{{ model.sharepoint_link }}</a></label>
          </v-col>
        </v-row>
      </template>
    </v-card-text>
  </div>
</template>
<script>
export default {
  props: {
    model: {
      type: Object
    },
    list: {
      type: Object
    },
    isWorkType: {
      type: Boolean
    },
    showPriceUpdateText: {
      type: Boolean
    },
    copyProduct: {
      type: Object
    },
    isAdmin: {
      type: Boolean
    }
  },
  data () {
    return {
      reInit: 0,
      reInitLoc: 0
    }
  },
  computed: {
    listOfTypes () {
      return [{
        text: this.$t('message.layout.product'),
        value: 'product'
      }, {
        text: this.$t('message.product.work'),
        value: 'work'
      }]
    },
    listOfVAT () {
      return [{
        text: '0%',
        value: 0
      }, {
        text: '12%',
        value: 12
      }, {
        text: '25%',
        value: 25
      }]
    }
  },
  mounted () {
    this.$eventBus.$on('deleteSuccess', (data) => {
      this.$root.$emit('snackbar', { snackbar: true, color: 'success', text: this.$t('message.common.deleteMsg') })
      this.$store.commit('hideDialog')
      if (data === 'productunitmatrix') this.$eventBus.$emit('updateProductUnits')
      if (data === 'productwarehouselocation') this.$eventBus.$emit('updateProductDefaultLocations')
    })
  },
  methods: {
    calculateGrosMarginValue () {
      this.$eventBus.$emit('calculateGrosMarginValue')
    },
    calculateSalesValue () {
      this.$eventBus.$emit('calculateSalesValue')
    },
    changesMade () {
      this.$store.commit('isChangesMade', true)
    },
    checkForNumberDuplication () {
      this.$eventBus.$emit('checkForNumberDuplication')
    },
    salesPriceHandler (target, field, type) {
      this.$eventBus.$emit('salesPriceHandler', { target, field, type })
    },
    addOrReomveProductUnit (type, index) {
      if (type === 'PUSH') {
        this.model.units.push({})
        this.reInit++
        // this.$set(this.model.units, this.model.units.length,  {})
      } else {
        if (this.model.units[index].id) {
          let payload = { ids: [ this.model.units[index].id ], url: `productunitmatrix/delete_multiple`, module: 'productunitmatrix' }
          this.$store.commit('showDeleteDialog', payload)
        } else {
          let self = this
          self.$store.commit('showDeleteDialog', {
            isLocalDelete: true,
            dialogOkCb: () => {
              self.model.units.splice(index, 1)
              self.reInit++
            }
          })
        }
      }
    },
    addOrReomveProductLocations (type, index) {
      if (type === 'PUSH') {
        this.model.defaultlocations.push({})
        this.reInitLoc++
      } else {
        if (this.model.defaultlocations[index].id) {
          let payload = { ids: [ this.model.defaultlocations[index].id ], url: `productwarehouselocation/delete_multiple`, module: 'productwarehouselocation' }
          this.$store.commit('showDeleteDialog', payload)
        } else {
          this.model.defaultlocations.splice(index, 1)
          this.reInitLoc++
        }
      }
    },
    checkIfLocationValid (index, warehouseId, locName) {
      this.$_executeApi('get', `/stocks/check_if_valid_location?warehouseid=${warehouseId}&locationName=${locName}`)
        .then((result) => {
          if (result && result.data > 0) {
            this.$set(this.model.defaultlocations, index, { ...this.model.defaultlocations[index], locationid: result.data })
          } else {
            this.$root.$emit('snackbar', { snackbar: true, color: 'error', text: this.$t('message.warehouse.notAValidLocation') })
            this.$set(this.model.defaultlocations, index, { ...this.model.defaultlocations[index], locationid: 0, locationname: '' })
          }
          this.reInitLoc++
        })
    },
    selectWarehouse (index) {
      const warehouse = this.list.warehouse.find(x => x.id === this.model.defaultlocations[index].warehouseid)
      if (warehouse) {
        const existingWarehouses = this.model.defaultlocations.filter((x, i) => i !== index)
        if (existingWarehouses.find(x => x.warehouseid === warehouse.id)) {
          this.$root.$emit('snackbar', { snackbar: true, color: 'error', text: this.$t('message.warehouse.warehouseExists') })
          this.$set(this.model.defaultlocations, index, { ...this.model.defaultlocations[index], warehouseid: 0, warehousename: '' })
        } else {
          this.$set(this.model.defaultlocations, index, { ...this.model.defaultlocations[index], warehousename: warehouse.name })
        }
        this.reInitLoc++
      }
    },
    updateSaleUnitInList (index, value) {
      // eslint-disable-next-line
      this.model.units.map(x => x.issaleunit = false)
      if (value) this.model.units[index].issaleunit = true
      this.reInit++
    }
  }
}
</script>
